import React from 'react';
import PropTypes from 'prop-types';
import css from './DisplayInformation.scss';

export default class DisplayInformation extends React.Component {

  // the starting index of the records currently being displayed
  get currentRecordsStartIndex() {
    // account for making this a user-friendly index
    return this.props.start + 1;
  }

  // the ending index of the records currently being displayed
  get currentRecordsEndIndex() {
    const displayEnd = this.props.start + this.props.itemsPerPage;
    return displayEnd > this.props.totalItems ? this.props.totalItems : displayEnd;
  }

  render() {
    return <div className={css['display-info']}>
      Displaying {this.currentRecordsStartIndex} - {this.currentRecordsEndIndex} of {this.props.totalItems} {this.props.itemName}
    </div>
  }

}

DisplayInformation.propTypes = {
  itemName: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired
};
